module.exports = __webpack_public_path__ + "static/media/aqua2.781866d9.jpg";